import { Grid } from "@scuf/common";
import "../Tostador/Tostador.css";
import "./LGases.css";

export default function LGases() {
  return (
    <>
      <Grid>
        <Grid.Row className="tostador-row">
          <Grid.Column className="tostador-column" width={6} mWidth={12}>
            {" "}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </>
  );
}
